import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2B2D42] text-white py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-6 md:mb-8">
          {/* Left Section - Logo and Info */}
          <div>
            <Link to="/">
              <img 
                src="https://static.readdy.ai/image/b2717fa299e25af1bb585f7256441db5/754657532bad912eeb6a0b9462e02f95.png" 
                alt="케어인슈 로고" 
                className="h-8 md:h-10 mb-4 md:mb-6 brightness-0 invert cursor-pointer"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </Link>
            <div className="space-y-1.5 md:space-y-2 text-xs md:text-sm text-white/70">
              <p>
                <span className="text-white/90">대표</span> 윤영관
              </p>
              <p>
                <span className="text-white/90">사업자등록번호</span> 120-87-02467
              </p>
              <p>
                <span className="text-white/90">주소</span> 서울특별시 구로구 디지털로26길 5 에이스하이엔드타워1차 202호
              </p>
              <p>
                <span className="text-white/90">이메일</span> info@careinsu.kr
              </p>
              <p>
                <span className="text-white/90">팩스</span> 0504-360-3358
              </p>
              <p className="pt-2">
                ⓒ 케어인슈. All Rights Reserved.
              </p>
            </div>
          </div>

          {/* Right Section - Contact */}
          <div className="md:text-right">
            <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4">고객센터</h4>
            <a href="tel:010-3055-3358" className="text-2xl md:text-3xl font-bold mb-2 block hover:text-white/80 transition-colors cursor-pointer">
              010-3055-3358
            </a>
            <div className="space-y-1 text-xs md:text-sm text-white/70 mb-4 md:mb-6">
              <p>평일 09:00~18:00</p>
              <p>주말 · 공휴일 휴무</p>
            </div>
            <div className="flex gap-2 md:gap-3 md:justify-end">
              <Link 
                to="/#consultation"
                onClick={(e) => {
                  if (window.location.pathname === '/') {
                    e.preventDefault();
                    const element = document.getElementById('consultation');
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                      });
                    }
                  }
                }}
                className="px-4 md:px-6 py-2 md:py-2.5 bg-white/10 hover:bg-white/20 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                상담신청
              </Link>
              <Link 
                to="/#product-intro"
                onClick={(e) => {
                  if (window.location.pathname === '/') {
                    e.preventDefault();
                    const element = document.getElementById('product-intro');
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                      });
                    }
                  }
                }}
                className="px-4 md:px-6 py-2 md:py-2.5 bg-white/10 hover:bg-white/20 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                상품안내
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
